import {
  COMPANY,
  EMAIL_REJECTION_SECTIONS,
  PRIVACY_CONSENT_SECTIONS,
  PRIVACY_POLICY_SECTIONS,
  REFUND_POLICY_SECTIONS,
  TERMS_OF_SERVICE_SECTIONS,
} from '@/constants/legalContent'
import { MALL_FULFILLMENT_LIMIT, MALL_NAME } from '@/constants/mall'

export const MALL_HELP_PATH = '/mall/help'

export interface MallHelpSection {
  title: string
  body: string
}

export interface MallHelpTopic {
  id: string
  label: string
  summary: string
  sections: MallHelpSection[]
}

const GUIDE_SECTIONS: MallHelpSection[] = [
  {
    title: '안내 방법',
    body: `${COMPANY.mallName} 고객센터는 전화 상담을 하지 않습니다. 주문·배송·환불 기준은 이 메뉴의 정책에서 확인하고, 개별 문의는 이메일로 보내 주세요.`,
  },
  {
    title: '연락',
    body: `이메일 ${COMPANY.email}
운영 시간 ${COMPANY.hours}
로그인 후에는 마이페이지의 문의 내역에서도 글을 남길 수 있습니다.`,
  },
  {
    title: '사업자',
    body: `${COMPANY.legalName}
대표 ${COMPANY.owner}
사업자등록번호 ${COMPANY.bizNumber}
${COMPANY.address}`,
  },
]

const ORDER_SECTIONS: MallHelpSection[] = [
  {
    title: '주문',
    body: `${MALL_NAME}은 로그인한 회원만 볼 수 있습니다. 주문도 로그인한 뒤에 합니다. 장바구니에서 판매업체별 배송비를 확인한 다음 결제 단계로 넘어갑니다.`,
  },
  {
    title: '토스페이먼츠',
    body: `결제는 토스페이먼츠로만 합니다. 카드 또는 간편결제는 결제 화면에서 바로 승인됩니다. 토스 앱이 없어도 카드로 낼 수 있습니다.
결제 인증이 끝나면, 주문 화면으로 돌아오지 못해도 서버가 승인을 마칩니다. 승인 전 10분이 지나면 그 결제는 취소되고, 주문 상세에서 다시 결제할 수 있습니다.
카드와 간편결제만 받습니다. 계좌이체·가상계좌·휴대폰을 고르면 그 결제는 취소되고 주문은 결제 대기로 남습니다.
토스페이먼츠 주문에는 세금계산서를 신청하지 않습니다.`,
  },
  {
    title: '결제 완료',
    body: `결제가 완료되면 판매업체에 주문이 전달됩니다. 그 전까지는 판매업체가 출고를 준비하지 않습니다.
결제 시점에 재고가 부족하면 그 결제를 바로 취소하고 주문도 취소합니다. 돈은 결제했던 카드 또는 간편결제로 돌아갑니다.`,
  },
]

const SHIPPING_SECTIONS: MallHelpSection[] = [
  {
    title: '출고',
    body: `배송은 판매업체별로 진행됩니다. 상품은 ${MALL_FULFILLMENT_LIMIT}에 받습니다. 출고는 상품에 적힌 당일 출고, 영업일, 주문 제작 기간을 따릅니다. 출고 배송비는 따로 받지 않고 판매가격에 포함되어 있습니다. 출고가 시작되면 주문 상세에서 택배사와 송장번호를 확인할 수 있고, 로그인한 회원은 배송조회로도 볼 수 있습니다.`,
  },
  {
    title: '배송 중',
    body: `배송이 시작된 뒤에는 주문을 바로 취소할 수 없습니다. 상품을 받은 뒤 반품으로 요청해 주세요.`,
  },
  {
    title: '배송 완료와 구매확정',
    body: `배송 완료 후 7일이 지나면 구매가 자동으로 확정됩니다. 그 전에 구매자가 직접 구매확정할 수도 있습니다. 구매확정 뒤에는 단순 변심 반품을 요청할 수 없습니다. 상품 하자·오배송은 구매확정 뒤에도 요청할 수 있습니다.`,
  },
]

export const MALL_HELP_TOPICS: MallHelpTopic[] = [
  {
    id: 'guide',
    label: '고객센터 안내',
    summary: '연락 방법과 사업자 정보입니다.',
    sections: GUIDE_SECTIONS,
  },
  {
    id: 'order',
    label: '주문 · 결제',
    summary: '토스페이먼츠 카드·간편결제 기준입니다.',
    sections: ORDER_SECTIONS,
  },
  {
    id: 'shipping',
    label: '배송',
    summary: '출고, 배송 중, 구매확정 기준입니다.',
    sections: SHIPPING_SECTIONS,
  },
  {
    id: 'refund',
    label: '취소 · 반품 · 환불',
    summary: '토스페이먼츠 결제 취소·반품 기준입니다. 이전 계좌이체 주문은 따로 적습니다.',
    sections: REFUND_POLICY_SECTIONS,
  },
  {
    id: 'terms',
    label: '이용약관',
    summary: '서비스 이용에 관한 기본 약관입니다.',
    sections: TERMS_OF_SERVICE_SECTIONS,
  },
  {
    id: 'privacy',
    label: '개인정보처리방침',
    summary: '개인정보 처리 원칙입니다.',
    sections: PRIVACY_POLICY_SECTIONS,
  },
  {
    id: 'privacy-consent',
    label: '개인정보 수집·이용 동의',
    summary: '회원가입과 서비스 제공에 필요한 개인정보 수집·이용 동의입니다.',
    sections: PRIVACY_CONSENT_SECTIONS,
  },
  {
    id: 'email',
    label: '이메일 무단수집 거부',
    summary: '이 사이트에 공개된 이메일 주소의 무단 수집을 거부합니다.',
    sections: EMAIL_REJECTION_SECTIONS,
  },
]

export function mallHelpPath(id = 'guide'): string {
  return `${MALL_HELP_PATH}/${id}`
}

export function findMallHelpTopic(id: string | undefined): MallHelpTopic {
  return MALL_HELP_TOPICS.find((topic) => topic.id === id) || MALL_HELP_TOPICS[0]
}
